import { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@nazka/nazka.mapframe.components';

import LoginModal from '@App/components/LoginModal/LoginModal';
import { useAuth } from '@App/components/AuthProvider/auth-provider.context';

import NavItem from './NavItem/NavItem';

import './nav.css';

function Nav() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { checkedAuthentication, isLoggedIn, logOut, userDetails } = useAuth();

  const accountName = userDetails?.email || userDetails?.username || '';
  const isActiveRoute = route => pathname === route || pathname.startsWith(`${route}/`);

  let accountNavigation = <div className="nav__account-placeholder" aria-hidden="true" />;

  if (checkedAuthentication) {
    accountNavigation = isLoggedIn
      ? (
          <NavItem
            icon="/img/icons/account.svg"
            isCollapsed={isCollapsed}
            showTooltip
            tooltipOpenOnClick
            tooltipClickable
            tooltipClassName="nav__account__tooltip"
            tooltipPlace="right"
            tooltip={(
              <Button
                className="nav__account__logout"
                css={{
                  'backgroundColor': 'var(--color-common-white)',
                  'border': 0,
                  'borderRadius': 0,
                  'color': 'var(--color-primary-main)',
                  '&:hover': {
                    backgroundColor: 'var(--color-primary-light)',
                    color: 'var(--color-common-white)',
                  },
                }}
                onClick={logOut}
                rootElProps={{ type: 'button' }}
              >
                Afmelden
              </Button>
            )}
          >
            <span className="nav__account__name" title={accountName}>{accountName}</span>
          </NavItem>
        )
      : (
          <NavItem
            icon="/img/icons/account.svg"
            isCollapsed={isCollapsed}
            onClick={() => setShowLoginModal(true)}
          >
            Aanmelden
          </NavItem>
        );
  }

  return (
    <div className={`nav${isCollapsed ? ' nav--collapsed' : ''}`}>
      <div className="nav__top">
        <NavLink className="nav__top__title" to="/">
          <span className="nav__top__title__part">{isCollapsed ? 'P' : 'Potentieelkaart'}</span>
          <span className="nav__top__title__part">{isCollapsed ? 'a' : 'aquathermie'}</span>
          <span className="nav__top__title__part">{isCollapsed ? 'V' : 'Vlaanderen'}</span>
        </NavLink>
        <NavItem
          icon="/img/icons/bronnen.svg"
          isCollapsed={isCollapsed}
          active={isActiveRoute('/bronnen')}
          onClick={() => navigate('/bronnen')}
        >
          Bronnen
        </NavItem>
        <NavItem
          icon="/img/icons/afnemers.svg"
          isCollapsed={isCollapsed}
          active={isActiveRoute('/afnemers')}
          onClick={() => navigate('/afnemers')}
        >
          Afnemers
        </NavItem>
        <div className="nav__top__divider" />
        <NavItem
          icon="/img/icons/installaties.svg"
          iconSize="19px"
          isCollapsed={isCollapsed}
        >
          Installaties
        </NavItem>
        <NavItem
          icon="/img/icons/layers.svg"
          iconSize="16.5px"
          isCollapsed={isCollapsed}
          active={isActiveRoute('/randvoorwaarden')}
          onClick={() => navigate('/randvoorwaarden')}
        >
          Randvoorwaarden
        </NavItem>
      </div>
      <div className="nav__bottom">
        <NavItem
          icon="/img/icons/info.svg"
          isCollapsed={isCollapsed}
        >
          Info / FAQ
        </NavItem>
        {accountNavigation}
        <div className="nav__bottom__divider" />
        <NavItem
          icon={`/img/icons/${isCollapsed ? 'expand' : 'collapse'}-sidebar.svg`}
          onClick={() => setIsCollapsed(!isCollapsed)}
          isCollapsed={isCollapsed}
        >
          Menu inklappen
        </NavItem>
      </div>
      {showLoginModal && <LoginModal isOpen={showLoginModal} setIsOpen={setShowLoginModal} />}
    </div>
  );
}

export default Nav;
